import { render, staticRenderFns } from "./ButtonsCol.vue?vue&type=template&id=1fe1151c&scoped=true"
import script from "./ButtonsCol.vue?vue&type=script&lang=js"
export * from "./ButtonsCol.vue?vue&type=script&lang=js"
import style0 from "./ButtonsCol.vue?vue&type=style&index=0&id=1fe1151c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fe1151c",
  null
  
)

export default component.exports